import type { CTA_Button } from '../../interface/CTA_Button';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useGetCTAContent = (slug: string) =>
  useQuery({
    queryKey: ['content', 'cta', slug],
    queryFn: () => getCTAContent(slug),
    enabled: !!slug,
  });

const getCTAContent = async (slug: string) => {
  const { data } = await api.get<CTA_Button>(
    apiConfig.routes.content.cta(slug)
  );
  return data;
};
